var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0791 26.2859C5.8791 26.2859 0.0791016 20.4859 0.0791016 13.2859C0.0791016 11.3859 0.479102 9.48589 1.2791 7.78589C2.0791 6.08589 3.2791 4.48589 4.7791 3.28589C5.1791 2.88589 5.8791 2.98589 6.1791 3.38589C6.4791 3.78589 6.4791 4.48589 6.0791 4.78589C4.7791 5.78589 3.7791 7.18589 3.0791 8.58589C2.4791 10.0859 2.0791 11.6859 2.0791 13.2859C2.0791 19.3859 6.9791 24.2859 13.0791 24.2859C19.1791 24.2859 24.0791 19.3859 24.0791 13.2859C24.0791 11.6859 23.6791 10.0859 22.9791 8.58589C22.2791 7.08589 21.2791 5.78589 19.9791 4.78589C19.5791 4.38589 19.4791 3.78589 19.8791 3.38589C20.2791 2.98589 20.8791 2.88589 21.2791 3.28589C22.7791 4.48589 23.9791 6.08589 24.7791 7.78589C25.6791 9.48589 26.0791 11.3859 26.0791 13.2859C26.0791 20.4859 20.2791 26.2859 13.0791 26.2859Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0791 14.2852C12.4791 14.2852 12.0791 13.8852 12.0791 13.2852V1.28516C12.0791 0.685156 12.4791 0.285156 13.0791 0.285156C13.6791 0.285156 14.0791 0.685156 14.0791 1.28516V13.2852C14.0791 13.8852 13.6791 14.2852 13.0791 14.2852Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.261e7159eabe9e91e5ded45101c5ea92.svg";
export { ForwardRef as ReactComponent };